module.exports = __webpack_public_path__ + "static/media/path_border_header.f8f6a7ba.png";